import { render, staticRenderFns } from "./CoursewareTypewriterBlock.vue?vue&type=template&id=51b8fe35&scoped=true&"
import script from "./CoursewareTypewriterBlock.vue?vue&type=script&lang=js&"
export * from "./CoursewareTypewriterBlock.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareTypewriterBlock.vue?vue&type=style&index=0&id=51b8fe35&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b8fe35",
  null
  
)

export default component.exports